import {
  TEACHER_PROFILE_DETAILS_FAILURE,
  TEACHER_PROFILE_DETAILS_SUCCESS,
} from "./profile.actionTypes";

const initialState = {
  teacher_details: null,
};

export default function teacherProfileReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case TEACHER_PROFILE_DETAILS_SUCCESS:
      return {
        ...state,
        teacher_details: payload,
      };
    case TEACHER_PROFILE_DETAILS_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
